import type { Entity } from '@marmon/shared/types/common';
import type { AlgoliaEntity } from '../types';

export class AlgoliaObject implements AlgoliaEntity {
	objectID!: string;
	createdAt!: number;
	updatedAt!: number;

	_tags?: string[];

	constructor(entity: Entity) {
		this.objectID = entity.id;
		this.createdAt = entity.createdAt.toMillis();
		this.updatedAt = entity.updatedAt.toMillis();
	}
}
